import React from 'react'

import classNames from 'classnames'

import NFIcon from '@components/shared/NFIcon'
import { adjustCommentsCount, adjustFavesCount, adjustViewsCount } from '@models/util/score.util'

type SocialIconType = 'favorites' | 'views' | 'comments'
interface Props {
  type: SocialIconType
  count: number
  className?: string
}

const SocialIcon: React.FC<Props> = ({ type, count, className }: Props) => {
  return (
    <p className={classNames('flex flex-row items-center', className)}>
      {count !== 0 && (
        <>
          <NFIcon
            icon={getIconName(type)}
            className="text-sm w-[13px] text-center mr-0.5 text-gray-icons dark:text-gray-icons-dm"
          />
          <span className="text-xs flex-1">{getAdjustedCount(type, count)}</span>
        </>
      )}
    </p>
  )
}

export default SocialIcon

function getIconName(type: SocialIconType): string {
  switch (type) {
    case 'favorites':
      return 'favorite-solid'
    case 'views':
      return 'eye-show'
    case 'comments':
      return 'comment'
    default:
      return ''
  }
}

function getAdjustedCount(type: SocialIconType, count: number): string {
  switch (type) {
    case 'favorites':
      return adjustFavesCount({ favorites_count: count })
    case 'views':
      return adjustViewsCount({ views_count: count })
    case 'comments':
      return adjustCommentsCount({ comments_count: count })
    default:
      return `${count}`
  }
}
